import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';

export const routes: Routes = [
  {
    path: 'app/issues/:issueKey',
    component: HomeComponent,
  },
];
